export const SCROLL_SPY_OFFSET = 90;
export const SCROLL_SPY_DEBOUNCE_MS = 100;

export const SECTION_OBSERVER_THRESHOLD = 0.15;
export const SECTION_OBSERVER_ROOT_MARGIN = '0px 0px -10% 0px';
export const SECTION_ANIMATION_COMPLETION_DELAY_MS = 1000;
